import React from 'react';
import { Box, Flex, Text } from 'pcln-design-system';
import { Pin } from 'pcln-icons';
import { truncateString } from '../../../../utils/truncateText';
const Header = ({
  hotelName,
  neighborhoodName
}) => {
  return React.createElement(Box, null, React.createElement(Text, {
    fontWeight: 'bold',
    fontSize: 1,
    lineHeight: '19px'
  }, truncateString(hotelName, 65)), React.createElement(Flex, {
    py: 1,
    alignItems: 'center'
  }, React.createElement(Pin, {
    color: 'primary.base',
    size: 16
  }), React.createElement(Text, {
    fontSize: 0,
    lineHeight: '16px',
    color: 'primary.base',
    ml: 1
  }, truncateString(neighborhoodName, 30))));
};
export default Header;